 function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }


const getSearchQueryFromMeeting = (meeting, service) => {
  switch (service) {
    case 'PARABOL':
      const {parabolSearchQuery} = meeting
      return {
        searchQueryString: _nullishCoalesce(parabolSearchQuery.queryString, () => ( undefined))
      }
    case 'github':
      const {githubSearchQuery} = meeting
      return {
        searchQueryString: _nullishCoalesce(githubSearchQuery.queryString, () => ( undefined))
      }
    case 'gitlab':
      const {gitlabSearchQuery} = meeting
      const {queryString, selectedProjectsIds} = gitlabSearchQuery
      return {
        searchQueryString: queryString,
        searchQueryFilters: _optionalChain([selectedProjectsIds, 'optionalAccess', _ => _.concat, 'call', _2 => _2()])
      }
    case 'jira':
      const {jiraSearchQuery} = meeting
      const {queryString: jiraQueryString, projectKeyFilters} = jiraSearchQuery
      return {
        searchQueryString: jiraQueryString,
        searchQueryFilters: projectKeyFilters.concat()
      }
  }
  return undefined
}

export default getSearchQueryFromMeeting
